import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
const OfflineNotification = ({ onDisplay }) => {
    const { t } = useTranslation();
    useEffect(() => {
        onDisplay();
    }, [onDisplay]);
    return (_jsx("div", Object.assign({ className: "container-with-sidenav container--fixed-height container-warning-status notification-fade" }, { children: t('NOTIFICATIONS.CONNECTION_OFFLINE') }), void 0));
};
export default OfflineNotification;
